<!-- 图书柜-卖书-我的售卖 -->
<template>
  <div class="BookcaseMySell">
    <div class="list-wrapper" v-if="list.length !== 0">
      <div class="list" v-for="(item, index) in list" :key="index" @click="goDetail">
        <img class="cover" :src="item.image" alt="">
        <div class="detail">
          <p class="bTit">{{item.name}}</p>
          <p class="intro">简介：{{item.intro}}</p>
          <p :class="['status', item.statusVal]">{{item.statusText}}</p>
        </div>
        <p class="price">￥{{item.price}}</p>
        <div class="bbtnArea">
          <p class="bbtn bbtn-r mini" @click="failureTap(item)" v-show="item.status == 1">点击下架</p>
          <p class="bbtn bbtn-p mini" @click="goOpenSave(item)" v-show="item.status == 0">开箱存物</p>
          <p class="bbtn bbtn-p mini" @click="goOpenGet(item)" v-show="item.status == 2">开箱取物</p>
        </div>
      </div>
    </div>
    <div class="noReserve two" v-else>
      <p class="text">当前无售卖商品，请在小程序我的信息-在卖商品中填写售卖商品信息</p>
    </div>

    <!-- 弹窗 -->
    <Dialog class="dialog" :visible.sync="dialogVisible">
      <template slot="body">
        <p class="text">确认要下架此商品？</p>
        <div class="dialog-footer">
          <p class="footer-btn" @click="dialogVisible = false">取消</p>
          <p class="footer-btn" @click="confirmFailure">确定</p>
        </div>
      </template>
    </Dialog>
    
    <!-- mqtt -->
    <Mqttws ref="mqttws" :topic="topic" msgIsHex notAutoConnect @getMessage="getPStatus"></Mqttws>
  </div>
</template>

<script>
  import Dialog from '@/components/Bookcase/Common/Dialog'
  import Mqttws from '@/components/Bookcase/Common/Mqttws'
  import { storage, messageError, messageSuccess, showLoading, hideLoading } from '../../../../static/js/utils/utility'
  import { checkData } from '../../../../static/js/utils/util'
  import { ECMallApi } from '../../../../static/Bookcase/js/api'
  import * as config from '../../../../static/js/config.js'
  import { showToast } from '../../../../static/turnoverCabinet/js/utility'
  let vm, timer

  export default {
    name:'BookcaseMySell',
    components: {
      Mqttws,
      Dialog
    },
    computed: {
    },
    data() {
      return {
        topic: '/'+ config.serverPort2 + '/down/' + config.deviceId + '/control/protocol/response', // 前端订阅主题（获取打印机状态）
        ctopic: '/'+ config.serverPort2 + '/down/' + config.deviceId + '/control/protocol',   // 推送主板订阅主题

        list: [],
        activeItem: '',

        dialogVisible: false,
        dialogInfo: {}
      }
    },
    created() {
      vm = this
      vm.getUserProduct()
    },
    mounted () {
    },
    methods: {
      //获取用户售卖的商品
      async getUserProduct () {
        let data = {
          cabinet_id: config.deviceId,
          type: 1,
          lost: 1
        }

        let res = await ECMallApi.getUserProduct(data)
        if(res.meta.code === 200) {
          let list = [...res.data]
          list.forEach(function(item, index){
            let status = item.status
            list[index].statusVal =  status === -1 ? 'failure' :
                                  status === 0 ? 'noon' : 
                                  status === 1 ? 'on' :
                                  status === 2 ? 'out' : ''
            list[index].statusText =  status === -1 ? '已失效' :
                                  status === 0 ? '未上架' : 
                                  status === 1 ? '已上架' :
                                  status === 2 ? '已下架' : ''
            list[index].intro = item.intro === '' ? '无' : item.intro
          })
          vm.list = [...list]
        }  else {
          messageError(res.meta.message)
        }
      },
      // 去商品详情
      goDetail () {
      } ,

      // 修改产品状态(状态 ：1上架 2下架3预约 4取消预约)
      async changeProductStatus (data) {
        console.log(data)
        showLoading('修改商品状态中')
        let res = await ECMallApi.changeProductStatus(data)
        hideLoading()
        if (res.meta.code === 200) {
          messageSuccess('修改成功')
          vm.dialogVisible = false
          vm.getUserProduct()
        } else {
          messageError(res.meta.message)
        }
      },

      /**下架操作 */
      // 点击下架
      failureTap (item) {
        if (item.is_book == 1) {
          showToast('该商品已被预约，无法下架')
          return
        }
        vm.dialogVisible = true
        vm.dialogInfo = item
      },
      // 确认下架
      confirmFailure() {
        let data = {
          pid: vm.dialogInfo.pid,
          status: 2
        }
        vm.changeProductStatus(data)
      },

      /** 开箱取物 */
      // 开箱取物
      goOpenGet (item) {
        vm.$store.state.ECMall_activeGoods = item
        vm.$store.state.eUserInfo.operateType = 'get'
        vm.openBox()
      },
      // 开箱门(卖书开箱取物（下架）为2)
      async openBox () {
        let data = {
          type: 2,
          cabinet_id: config.deviceId,
          pid: vm.$store.state.ECMall_activeGoods.pid
        }

        console.log(data)
        let res = await ECMallApi.openBox(data)
        hideLoading()
        if (res.meta.code === 200) {
          // console.log(res)
          vm.$router.push('/Bookcase/SOpenBox')
        } else {
          // messageError(res.meta.message)
          messageError('开箱失败,请点击右下方按钮联系客服')
        }
      },



      /** 开箱存物 */
      // 去开箱存物
      goOpenSave (item) {
        vm.inquirePStatus()
        vm.activeItem = item
        vm.$store.state.ECMall_activeGoods = vm.activeItem
        vm.$store.state.eUserInfo.operateType = 'save'
      },
      // 查询打印机状态
      inquirePStatus () {
        var msg = 'a55500000000000000000001012c440000'
        var bcc = checkData(msg)
        vm.$refs.mqttws.onConnection(function () {
          // 发送指令
          vm.$refs.mqttws.send(vm.ctopic, msg+bcc)
          showLoading('查询打印机状态中')
        })
      },
      // 获取打印机状态
      getPStatus (data) {
        console.log('mqtt返回信息：', data)
        if (data) {
          var str = data.substring(2,data.length-2);//截取字符串的第二到倒数第二的数据
          var num = checkData(str)
          var bbc = data.substr(data.length-2)// 校验bbc是否正确
          if (num === bbc) {
            let status = data.substring(data.length-4, data.length-2)
            // console.log('status', status)
            // 不缺纸
            if (status === '00') {
              hideLoading()
              vm.$router.push('/Bookcase/SScanCode')
            // 缺纸
            } else {
              vm.saveNotice()
            }
          } else {
            messageError('获取打印机状态失败')
          }
        }
      },
      // 缺纸发送通知信息至后台
      async saveNotice () {
        let data = {
          cabinet_id: config.deviceId,
          notice: '打印机缺纸'
        }

        let res = await ECMallApi.saveNotice(data)
        hideLoading()
        if (res.meta.code === 200) {
          // console.log('缺纸记录成功')
          showToast('打印机缺纸，无法上架书籍!请点击右下方按钮联系客服')
        } else {
          messageError(res.meta.message)
        }
      },
    },
    watch: {
    },
  }
</script>

<style lang="less">
.Bookcase{
  .BookcaseMySell {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .list-wrapper {
      width: 100%;
      height: 100%;
      padding:  0 0.44rem;
      margin: 0.3rem 0;
      overflow-x: hidden;
      overflow-y: scroll;
      .list {
        width: 100%;
        padding: 0.28rem 0.96rem 0.3rem 0.29rem;
        margin-top: 0.3rem;
        background-color: #ffffff;
        border-radius: 0.05rem;
        box-shadow: 0 0.02rem 0.24rem rgba(0, 0, 0, 0.21);
        position: relative;
        display: flex;
        &:first-child {
          margin-top: 0;
        }
        .cover{
          flex-shrink: 0;
          width: 1.52rem;
          height: 2.02rem;
          margin-right: 0.3rem;
        }
        .detail {
          // width: 100%;
          .bTit {
            margin-top: 0.12rem;
            font-size: 0.34rem;
            line-height: 1;
            font-weight: bold;
          }
          .intro {
            max-width: 6.35rem;
            height: 0.64rem;
            margin: 0.22rem 0 0.3rem;
            font-size: 0.24rem;
            line-height: 0.32rem;
            color: #999999;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
          .status {
            width: 1.3rem;
            height: 0.49rem;
            line-height: 0.47rem;
            font-size: 0.28rem;
            text-align: center;
            box-sizing: border-box;
            border: 0.01rem solid transparent;
            &.noon {
              color: #9f483f;
              border-color: #cda09b;
              background-color: #fde6e4;
            }
            &.on {
              color: #5fc268;
              border-color: #acdfb0;
              background-color: #e7fbe9;
            }
            &.out {
              color: #b9b6b6;
              border-color: #dedede;
              background-color: #f1f1f1;
            }
          }
        }
        .price {
          font-size: 0.34rem;
          line-height: 1;
          font-weight: bold;
          color: #d72f2f;
          position: absolute;
          right: 1.03rem;
          top: 0.43rem;
        }
        .bbtnArea {
          display: flex;
          position: absolute;
          right: 0.4rem;
          bottom: 0.26rem;
          .bbtn {
            width: 1.8rem;
            &+.bbtn {
              margin-left: 0.15rem;
            }
          }
        }
      }
    }
    .noReserve {
      width: 8.4rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Bookcase/Sell/MySell.vue